import {
  ProgramBox,
  ProgramContent,
  ProgramFlex,
  ProgramStack,
  ProgramTitle,
  ProgramText,
  ProgramImage,
  useProgram
} from "planby";
import { useDispatch, useSelector } from "react-redux";
import { getScheduleModal } from "../../../Redux/ScheduleModal/scheduleModalSlice";
import { convertTimeToLocal } from "../../../utils/utils";
import { getSelectedSchedule } from "../../../Redux/SelectedScheduleChannel/selectedScheduleChannelSlice";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";


export const ProgramItem = ({ program, onShowClick, ...rest }) => {
  const {
    styles,
    formatTime,
    set12HoursTimeFormat,
    isLive,
    isMinWidth
  } = useProgram({
    program,
    ...rest
  });
  const dispatch = useDispatch()
  const { data } = program;
  const { image, title, since, till, originalTitle, originalDescription, originalImage, originalStart, originalEnd, thumbnail, channel_id } = data;
  const sinceTime = formatTime(since, set12HoursTimeFormat()).toLowerCase();
  const tillTime = formatTime(till, set12HoursTimeFormat()).toLowerCase();
  
  const hideText = !title;
  
  const selectedSchedule = useSelector((state) => state?.selectedSchedule?.value);
  const selectedChannel = useSelector((state) => state?.selectedChannel?.value);
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const activeChannelId = queryParams.get('c') || selectedChannel?.selectedChannel?.channel_id || selectedChannel?.channel_id;
  const isSelectedChannelRow = activeChannelId && (activeChannelId?.toString() === data?.channel_id?.toString());

  useEffect(() => {
    if (isLive) {
      // let initialSchedule =localStorage.getItem("initialScheduleAdded")? localStorage.getItem("initialScheduleAdded"):"false"
      // if(initialSchedule === "false" || initialSchedule === null){
      // dispatch(
      //   getSelectedSchedule({
      //     selectedSchedule:data
      //   })
      // )
      // localStorage.setItem("initialScheduleAdded","true")
      // }else{
      if (selectedSchedule?.channel_id && selectedSchedule?.channel_id === data?.channel_id) {
        if (isLive) {
          dispatch(
            getSelectedSchedule({
              selectedSchedule: data
            })
          )
          navigate("/live-channels?c="+data?.channel_id, { state: { ...data, homelive: true } });
        }
      }

      // }
    }

  }, [isLive, selectedSchedule])

  useEffect(() => {
    if (selectedChannel?.channel_id === data?.channel_id) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      dispatch(
        getSelectedSchedule({
          selectedSchedule: data
        })
      )
    }
  }, [selectedChannel])
  const liveShowHandler = () => {
    if (isLive) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      dispatch(
        getSelectedSchedule({
          selectedSchedule: data
        })
      )
    }
    // else{
    //   let scheduleData={
    //     isOpen:true,
    //     data:data
    //   }
    //   dispatch(
    //     getScheduleModal({
    //       scheduleModal:scheduleData,
    //     })
    //   )

    // }
  }
  const handleClick = () => {
    if (onShowClick) {
      let thumb = originalImage || image || thumbnail;
      onShowClick({
        ...data,
        title: originalTitle || title,
        description: originalDescription || data.description,
        thumbnail: thumb,
        start: originalStart || since,
        end: originalEnd || till
      });
    }
  };
  return (
    <ProgramBox
      width={styles.width}
      style={{
        ...styles.position,
        ...(isSelectedChannelRow ? { zIndex: 5 } : {})
      }}
      onClick={isLive ? liveShowHandler : handleClick}
      className={isSelectedChannelRow ? "selected-epg-program-box" : ""}
    >
      <ProgramContent
        width={styles.width}
        isLive={isLive}
        style={{
          ...(isSelectedChannelRow ? {
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
            borderTop: '1px solid rgba(255, 255, 255, 0.4)',
            borderBottom: '1px solid rgba(255, 255, 255, 0.4)'
          } : {})
        }}
      >
        <ProgramFlex>
          {/* <ProgramImage src={image} alt="Preview" /> */}
          {isLive && isMinWidth && image && <ProgramImage className="epg-program-thumbnail" src={image} alt="Preview" />}
          <ProgramStack>
            {!hideText && <ProgramTitle>{title}</ProgramTitle>}
            {!hideText && (
              <ProgramText className="epg-program-time">
                {sinceTime} - {tillTime}
              </ProgramText>
            )}
          </ProgramStack>
        </ProgramFlex>
      </ProgramContent>
    </ProgramBox>
  );
};

